import { ChangeDetectionStrategy, Component } from '@angular/core';


@Component({
  standalone: true,
  imports: [],
  selector: 'app-login-header',
  template: `
    <div
      class="mx-auto size-24 flex items-center justify-center rounded-full bg-gray-300 text-black"
    >
      <svg
        class="size-16 text-gray-50"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
        ></path>
      </svg>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {}
